import React, { useCallback, useState } from "react";
import { debounce } from "../helper";
import searchIcon from "../images/search-icon.png";

function Search({ handleSearchInput, setSearchLoader }) {
  const [search, setSearch] = useState("");

  const setSearchString = useCallback(
    debounce((e) => {
      handleSearchInput(e);
    }, 500),
    []
  );

  return (
    <div className="relative">
      <img className="absolute transform -translate-y-1/2 left-4 top-1/2" src={searchIcon} alt={searchIcon} />
      <input
        className="w-full bg-gray-200 border-2 border-gray-300 rounded text-gray-600 h-11 pl-10 p-2.5 focus:outline-primary placeholder:text-dark focus:placeholder:opacity-0"
        name="search"
        id="search"
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
          setSearchLoader(true);
          setSearchString(e);
        }}
        placeholder="Denner, .."
      />{" "}
    </div>
  );
}

export default Search;
